import React from "react";
import SubHeading from "../common/SubHeading";
import { useFormSection, FormSectionProps } from "../../hooks/useFormSection";

const psychosocialQuestions = [
  { key: "lessVital", label: "Do you feel less vital than you did one year ago?" },
  { key: "likeYourself", label: "Do you like yourself as you are today?" },
  { key: "confident", label: "Do you feel confident?" },
  { key: "stressReducesQuality", label: "Do you believe stress is currently reducing your quality of life?" },
  { key: "meaningAndPurpose", label: "Do you feel your life has meaning and purpose?" },
  { key: "likeWork", label: "Do you like the work you do?" },
  { key: "timeMoneyResponsibilities", label: "Do you spend the majority of your time and money to fulfill responsibilities and obligations?" },
  { key: "difficultToTrust", label: "Do you find it difficult to trust others?" },
  { key: "overwhelmed", label: "Do you often feel overwhelmed by life?" },
  { key: "practiceMeditation", label: "Do you practice meditation or relaxation techniques?" },
  { key: "abusedOrTrauma", label: "Have you ever been abused or experienced a significant trauma?" },
];

const relaxationTechniques = [
  "Yoga", "Deep breathing", "Massage", "Co-regulation", "Meditation", "Imagery",
  "Tapping", "Grounding (nature)", "Tai Chi", "Prayer", "5 Senses", "Physical Activity"
];

const PsychosocialProfileSectionV2: React.FC<FormSectionProps> = (props) => {
  const { Field } = useFormSection(props);

  return (
    <section>
      <SubHeading>Psychosocial Profile</SubHeading>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {psychosocialQuestions.map((q) => (
          <Field
            key={q.key}
            path={`psychosocialProfile.${q.key}`}
            label={q.label}
            type="checkbox"
          />
        ))}
      </div>
      
      <div className="mt-4">
        <label className="block text-brand-stone-700 mb-2 font-medium">
          Have you tried any relaxation techniques?
        </label>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 bg-brand-stone-50 p-4 rounded-lg">
          {relaxationTechniques.map((tech) => {
            const key = tech.toLowerCase().replace(/ \(.+\)/g, "").replace(/ /g, "");
            return (
              <Field
                key={key}
                path={`psychosocialProfile.relaxationTechniques.${key}`}
                label={tech}
                type="checkbox"
              />
            );
          })}
        </div>
      </div>
      
      <Field
        path="psychosocialProfile.stressfulEvents"
        label="Do any events/moments in your life stand out as being more stressful? If yes, describe:"
        type="textarea"
        rows={3}
      />
      
      <Field
        path="psychosocialProfile.worryMost"
        label="What do you worry about most in your life?"
        type="textarea"
        rows={3}
      />
      
      <Field
        path="psychosocialProfile.relieveStress"
        label="How do you relieve stress and relax?"
        type="textarea"
        rows={3}
      />
    </section>
  );
};

export default PsychosocialProfileSectionV2;